module.exports = __webpack_public_path__ + "static/img/t_s.235b29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t_s.png
// module id = l2pE
// module chunks = 1